import React from 'react';
import { FaBuilding, FaSpinner } from 'react-icons/fa';

/**
 * Selector de proyecto para pantallas RRHH en contexto corporativo.
 * No renderiza nada si isCorporativo es false.
 */
const RrhhProyectoSelector = ({
  isCorporativo,
  proyectos = [],
  proyectoId,
  onChange,
  loading = false,
  className = '',
}) => {
  if (!isCorporativo) return null;

  return (
  <div
    className={`dh-alert dh-alert-info d-flex flex-wrap align-items-center gap-3 mb-3 ${className}`}
    style={{ borderRadius: 10 }}
  >
    <div className="d-flex align-items-center gap-2 fw-semibold">
      <FaBuilding />
      <span>Proyecto de trabajo (RRHH)</span>
    </div>
    {loading ? (
      <span className="d-flex align-items-center gap-2 text-muted">
        <FaSpinner className="fa-spin" /> Cargando proyectos…
      </span>
    ) : (
      <select
        className="dh-form-control"
        style={{ maxWidth: 360, minWidth: 220 }}
        value={proyectoId || ''}
        onChange={(e) => onChange(e.target.value ? Number(e.target.value) : null)}
      >
        <option value="">— Seleccione un proyecto —</option>
        {proyectos.map((p) => (
          <option key={p.id} value={p.id}>
            {p.nombre || `Proyecto #${p.id}`}
          </option>
        ))}
      </select>
    )}
    {!loading && proyectos.length === 0 && (
      <span className="text-muted small">No hay proyectos disponibles para su usuario.</span>
    )}
  </div>
  );
};

export default RrhhProyectoSelector;
